const menus = {
  all: [
    {
      title: 'Home',
      icon: 'mdi-home',
      to: 'Home'
    },
    {
      title: 'Fulfillment',
      icon: 'mdi-receipt',
      to: 'Fulfillment'
    },
    {
      title: 'Brand',
      icon: 'mdi-receipt',
      to: 'BrandList'
    }
  ],
  other: [
    {
      title: 'Home',
      icon: 'mdi-home',
      to: 'Home'
    },
    {
      title: 'Fulfillment',
      icon: 'mdi-receipt',
      to: 'Fulfillment'
    }
  ]
}

export default menus
